import classNames from "classnames"
import React, { useId } from "react"

import type { InputProps } from "../Input/Input"
import { Input } from "../Input/Input"

export type FormInputProps = InputProps & {
  label?: string
  labelClassName?: string
  inputClassName?: string
  children?: React.ReactNode
}

export const FormInput = ({
  className,
  children,
  label,
  labelClassName,
  inputClassName,
  size = "md",
  ...inputProps
}: FormInputProps) => {
  const isSm = size === "sm"
  const backupId = useId()
  const id = inputProps.id || backupId

  return (
    <div className={classNames("form-input", className)}>
      {!!label && (
        <label htmlFor={id} className={classNames("form-input__label", labelClassName)}>
          {label}
        </label>
      )}
      <Input
        {...inputProps}
        id={id}
        size={size}
        className={classNames("form-input__input", isSm && "form-input__input--sm", inputClassName)}
      />
      {children}
    </div>
  )
}
